import React, { Component } from 'react';
import axios from 'axios';
import '../../Asset/Css/Site.css';
import Select from 'react-select';
import global from '../global';
import ReCAPTCHA from 'react-google-recaptcha';
import 'react-notifications-component/dist/theme.css'
import { Card, Row, Col, InputGroup, FormControl, Modal, Button } from 'react-bootstrap';
import '../../Asset/Css/util.css';
import '../../Asset/Css/main.css';
import { config } from '../../Constants';
import { store } from 'react-notifications-component';
import ReactNotification from 'react-notifications-component';
import mainBG from '../../Asset/Images/easy-dividend-bg.png';
import goBack from '../../Asset/Images/previous-icon.png';
import { loadCaptchaEnginge, LoadCanvasTemplate, LoadCanvasTemplateNoReload, validateCaptcha } from 'react-simple-captcha';
import EasyDividendLogo from '../../Asset/Images/easy-dividend-logo.png';
import DivPdf from '../../Asset/documents/Data Privacy Policy-BIL.pdf';

export class Resident extends Component {
    static displayName = Resident.name;

    constructor(props) {
        super(props);
        this.state = {
            isVerified: false,
            DPID: '',
            residentDetails: [],
            companyList: [],
            BeneficiaryName: '',
            PAN: '',
            AssignmentCode: -1,
            AssignmentName: '',
            isSearchable: true,
            formErrors: '',
            url:'',
            isOpen: false,
            isYesOpen: false,
            isModalOpen: false,
            flag: 'R',
            Captcha: '',
            showVerifiedDetails: 'none',
            isCaptchaVisible: 'block',
            isDPIDDisable: false,
            isBASF: 'none',
            isChk: 1
        };

        this.initialState = this.state;

        this.handleChange = this.handleChange.bind(this);
        this.handleVerify = this.handleVerify.bind(this);
        this.handleCompany = this.handleCompany.bind(this);

    }

    componentDidMount() {
        loadCaptchaEnginge(6);
    };

    checkCaptcha = () => {
        let user_captcha_value = this.state.Captcha;

        if (validateCaptcha(user_captcha_value) == true) {
            return true;
        }
        else {
            return false;
        }

    };
    openModal = () => this.setState({ isOpen: true });

    closeModal = () => this.setState({ isOpen: false });

    closeYesModal = () => this.setState({ isYesOpen: false });

    handleChange(e) {

        const { name, value } = e.target;
        this.setState({ [name]: value });

    }

    handleCheckBox(e) {
        const checked = e.target.checked;

        if (checked) {
            this.setState({
                isChk: 1
            });
        }
        else {
            this.setState({
                isChk: 0
            });
        }
    }

    handleVerify = (e) => {
        debugger

        if (this.state.DPID == "" || this.state.DPID == null) {
            this.showNoti("Notification", "DP ID/Folio ID is required", "warning");
            return;
        }

        this.setState({
            flag: 'R'
        });

        const objLogin = this.state;


        axios.post(global.UserManagement.VerifyDPIDAPI, objLogin,
            { responseType: 'json' })
            .then(response => {
                if (response.status) {

                    this.setState({
                        residentDetails: response.data.data,
                        showVerifiedDetails: "block",
                        isCaptchaVisible: "none",
                        isDPIDDisable: true,
                        isYesOpen: false,
                    });

                    if (response.data.status) {

                        const optionsCompany = response.data.AssignmentList.map(d => ({
                            "value": d.ID,
                            "label": d.Label
                        }))

                        this.setState({
                            companyList: optionsCompany,
                            BeneficiaryName: this.state.residentDetails[0].BeneficiaryName,
                            PAN: this.state.residentDetails[0].PAN
                        })

                    }
                    else {

                        this.setState({
                            showVerifiedDetails: "none",
                            isCaptchaVisible: "block",
                            isDPIDDisable: false,
                            isYesOpen: false,
                        });

                        this.setState({
                            BeneficiaryName: '',
                            PAN: '',
                            isOpen: true,
                            isYesOpen: false,
                            companyList: []
                        });

                    }

                }
                else {
                    this.setState({
                        residentDetails: [],
                        showVerifiedDetails: "none",
                        isCaptchaVisible: "block",
                        isDPIDDisable: false
                    });
                }
            })
            .catch(error => {
                console.log(error);
            })  
        
        
    }

   
    onCAPTCHAChange = (e) => {
        this.setState({ isVerified: true });
    }

    handleCompany = (e) => {

        if (e.label == "BASF INDIA LIMITED") {
            this.setState({
                AssignmentCode: e.value,
                AssignmentName: e.label,
                isBASF: 'block',
                isChk: 0
            });
        }
        else {
            this.setState({
                AssignmentCode: e.value,
                AssignmentName: e.label,
                isBASF: 'none',
                isChk: 1
            });
        }
    }

    handleCheckPANInMultipleType = (e) => {

        if (this.state.DPID == "" || this.state.DPID == null) {
            this.showNoti("Notification", "DP ID/Folio ID is required", "warning");
            return;
        }

        if (this.checkCaptcha()) {
            this.setState({
                flag: 'R'
            });

            const objLogin = this.state;

            axios.post(global.UserManagement.CheckPANinMultipleTypeAPI, objLogin,
                { responseType: 'json' })
                .then(response => {
                    debugger
                    if (response.data.status) {

                        this.setState({
                            isYesOpen: true
                        });
              
                    }
                    else {

                        this.handleVerify(e);
                    }
                })
                .catch(error => {
                    console.log(error);
                })
        }
        else {
            this.showNoti("Notification", "Captcha Does Not Match", "danger");
            return;
        }
    }

    MoveToNR = (e) => {
        window.location.href = config.url.Web_URL + '/NonResident';
    }

    handleAccept = (e) => {
       
        if (this.state.PAN.substring(3, 4) == "P") {
            debugger;

            window.location.href = config.url.Web_URL + '/Resident/Dashboard?AC=' + window.btoa(this.state.AssignmentCode);
        }
        else if (this.state.PAN == "" || this.state.PAN == null) {
            window.location.href = config.url.Web_URL + '/Resident/Dashboard?AC=' + window.btoa(this.state.AssignmentCode);
        }
        else {
            window.location.href = config.url.Web_URL + `/Resident/Others?AC=` + window.btoa(this.state.AssignmentCode);
        }
    }

    handleProceed = (e) => {
        this.state.flag = 0;
        e.preventDefault();

        if (this.state.DPID == "" || this.state.DPID == null) {
            this.showNoti("Notification", "DP ID/Folio ID is required.", "warning");
            return;
        }

        if (this.state.AssignmentCode == -1 || this.state.AssignmentCode == "" || this.state.AssignmentCode == null) {
            this.showNoti("Notification", "Listed Company Name is required.", "danger");
            return;
        }

        if (this.state.AssignmentName == "BASF INDIA LIMITED") {
            this.setState({ isModalOpen: true });
            return;
        }
        else {   
            if (this.state.PAN.substring(3, 4) == "P") {
                window.location.href = config.url.Web_URL + '/Resident/Dashboard?AC=' + window.btoa(this.state.AssignmentCode) + '&flag=' + window.btoa(this.state.flag);
            }
            else if (this.state.PAN == "" || this.state.PAN == null) {
                window.location.href = config.url.Web_URL + '/Resident/Dashboard?AC=' + window.btoa(this.state.AssignmentCode) + '&flag=' + window.btoa(this.state.flag);
            }
            else {
                window.location.href = config.url.Web_URL + `/Resident/Others?AC=` + window.btoa(this.state.AssignmentCode);
            }
        }
    }

    handleSendEmail = (e) => {

        this.setState({
            isOpen: false
        });

        window.location.href = config.url.Web_URL + `/Resident/SendEmail`;

    }

    handleCancel = (e) => {
        e.preventDefault();
        window.location.href = config.url.Web_URL;
    }

    closeModalN = () => {
        this.setState({ isModalOpen: false })
    };

    showNoti(title, message, type) {
        store.addNotification({
            title: title,
            message: message,
            type: type,
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
                duration: 10000,
                onScreen: true
            }
        });
    };

    render() {
        const {
            isSearchable
        } = this.state;

        return (
            <div>
                <ReactNotification />


                <div class="limiter">
                    <div class="container-login100" style={{ backgroundImage: 'url("'+mainBG+'")' }}>
                        <div className="content-page">
                            <img src={EasyDividendLogo} alt="Logo" className="logo-img" />
                            <Row className="">
                                <Col md={1}>
                                </Col>
                                <Col md={5} className="login-form-1">
                                    <h3>Note</h3>

                                    <div className="form-group">
                                        Members with NSDL account: 8-character DP ID followed by 8-digit client ID. (For example, if your DP ID is IN300*** and Client ID is 12******, then IN300***12******)
                                    </div>
                                    <div className="form-group">
                                        Members with CSDL account: 16-digit Beneficiary ID. (For example, if your Beneficiary ID is 12**************, then 12**************)
                                    </div>
                                    <div className="form-group">
                                        Dear Shareholder, In case of shareholder having multiple Folio No/DPID & Client, then any Folio No/DPID & Client can be used to create the login credentials. Any Folio No/DPID & Client and Permanent Account Number (PAN) can be used for registration at this portal. The Tax forms or various documents submitted at the portal would be considered for all other Folio No/DPID & Client which has same Permanent Account Number (PAN) registered as per the information available with the depositories (NSDL/CDSL) or by the Registrar.
                                    </div>
                                </Col>
                                <Col md={5} className="login-form-2">
                                    <h3 className="xlogin-form-header legend lastdocTitle">Resident Shareholder</h3>
                                    <label className="required-field">DP ID/Folio ID:</label>
                                    <FormControl type="text" name="DPID" key="txtDPID" className="m-t-10" maxLength="20"
                                        value={this.state.DPID}
                                        placeholder="DP ID/Folio ID"
                                        onChange={this.handleChange}
                                        disabled={this.state.isDPIDDisable}
                                    />
                  
                                    <div style={{ display: `${this.state.isCaptchaVisible}` }}>
                                        <label className="required-field m-b-20 m-t-20">Enter Captcha:</label>
                                        <LoadCanvasTemplate className="w-100" />
                                        <FormControl type="text" name="Captcha" key="txtCaptcha" className="m-t-10" maxLength="6"
                                            value={this.state.Captcha}
                                            onChange={this.handleChange}
                                            placeholder="Max 6 Characters"
                                            autoComplete="off"
                                        />
                                        <button className="btn btn-primary float-left w-100 m-r-10 m-b-10 m-t-10" onClick={this.handleCheckPANInMultipleType} >
                                            Verify
                                        </button>                                        
                                    </div>
                
                                    <div style={{ display: `${this.state.showVerifiedDetails}` }}>
                                        <label className="m-t-20">Shareholder Name as per Trading Account:</label>
                                        <FormControl type="text" name="BeneficiaryName" key="txtBeneficiaryName" className="m-t-10" maxLength="100"
                                            value={this.state.BeneficiaryName}
                                            disabled={true}
                                        />

                                        <label className="m-t-20">PAN:</label>
                                        <FormControl type="text" name="PAN" key="txtPAN" className="m-t-10" maxLength="100"
                                            value={this.state.PAN}
                                            disabled={true}
                                        />

                                        <label className="required-field m-t-20">Listed Company Name:</label>
                                        <Select
                                            className="basic-single"
                                            classNamePrefix="select Listed Company"
                                            placeholder="Select Company"
                                            value={this.state.companyList.find(obj => obj.value === this.state.AssignmentCode)}
                                            isSearchable={isSearchable}
                                            options={this.state.companyList}
                                            onChange={this.handleCompany}
                                        />

                                        <div className="m-t-20 labelNote" style={{ display: this.state.isBASF }}>
                                            <input type="checkbox" name="myCheckbox" value={this.state.isChk} onChange={this.handleCheckBox.bind(this)} /> I hereby give my consent for use of these documents/information for carrying out withholding tax compliances by BASF Limited and/or its consultants
                                        </div>

                                        <button class="btn btn-primary float-right w-100 m-b-10 m-t-10" onClick={this.handleProceed} disabled={!this.state.isChk}>
                                            Proceed
                                        </button>
                                    </div>
                                     
                                    <img src={goBack} class="go_back" onClick={this.handleCancel} alt="Go to previous page" title="Go to previous page" />
                                </Col>
                                <Col md={1}>
                                </Col>
                            </Row>
                            <Row>
                                <Modal show={this.state.isOpen} onHide={this.closeModal}>
                                    <Modal.Header closeButton>
                                        <Modal.Title className="modal_title">DP ID/Folio ID Not Found !</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body className="modal_body">
                                        Oops! we didn't find your records in the system, seeems you have recently purchased your shares or your details are not present with RTA.  In that case Email us the Form 15 G/H Declaration.
                                            </Modal.Body>
                                    <Modal.Footer>
                                        <Button class="btn btn-primary float-right m-r-10 m-b-10" variant="primary" onClick={this.handleSendEmail}>
                                            Send Email
                                         </Button>

                                        <Button variant="dark" onClick={this.closeModal}>
                                            Close
                                        </Button>
                                        
                                    </Modal.Footer>
                                </Modal>

                            </Row>
                            <Row>
                                <Modal show={this.state.isYesOpen} onHide={this.closeYesModal}>
                                    <Modal.Header closeButton>
                                        <Modal.Title className="modal_title">Notification</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body className="modal_body">
                                        You have a PAN where the status is non-resident. Do you still wish to furnish declaration under Resident tab?
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button class="btn btn-primary float-right m-r-10 m-b-10" variant="primary" onClick={this.handleVerify}>
                                            Yes
                                         </Button>
                                        <Button variant="dark" onClick={this.MoveToNR}>
                                            No
                                        </Button>

                                    </Modal.Footer>
                                </Modal>

                            </Row>
                        </div>
                    </div>
                </div>

                <Modal show={this.state.isModalOpen} onHide={this.closeModalN}>
                    <Modal.Header closeButton>
                        <Modal.Title className="modal_title">Data Privacy Policy</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="modal_body">
                        <iframe src={DivPdf} height={"350"} width={"100%"} />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button class="btn btn-primary float-right m-r-10 m-b-10" variant="primary" onClick={this.handleAccept}>
                            I Accept
                        </Button>

                        <Button variant="dark" onClick={this.closeModalN}>
                            Close
                        </Button>

                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}